//#region Imports Packages and Libs

import { BaseService } from "./base_service";
import { HttpRequest } from "../helpers/http_request";
import { TranscriptApiResponse, SendTranscriptParams } from "../types/components/transcript";
import { TranscriptValidator } from "./transcript/transcript_validator";
import { TranscriptRequestBuilder } from "./transcript/transcript_request_builder";
import { TranscriptResponseHandler } from "./transcript/transcript_response_handler";

//#endregion

//#region Define the Transcript Service Class

/**
 * The `TranscriptService` class handles all API calls related to transcript functionality.
 * It extends BaseService to inherit common functionality like appUrl access.
 */
export class TranscriptService extends BaseService {
	/**
	 * Sends a transcript via email to specified recipients
	 * @param {SendTranscriptParams} params - Object containing all parameters for the transcript request
	 * @returns {Promise<TranscriptApiResponse>} - API response containing status and message
	 */
	async sendTranscript(params: SendTranscriptParams): Promise<TranscriptApiResponse> {
		try {
			// Input validation
			const validationResult = TranscriptValidator.validate(params);
			if (!validationResult.isValid) {
				return validationResult.errorResponse;
			}

			const { primaryEmail = "", additionalEmails = [], note = "" } = params;

			// Prepare request payload
			const requestData = TranscriptRequestBuilder.buildPayload(primaryEmail, additionalEmails, note);

			// Send request to API
			const request = new HttpRequest(`${this.appUrl}Default/SendTranscript`);

			// This is for TESTING purposes only. Comment it before deployment.
			//const request = new HttpRequest(`https://chat.satisfi4.com/Default/SendTranscript/`);
			const response = await request.sendPost(requestData);

			// Process the API response
			return TranscriptResponseHandler.processResponse(response);
		} catch (error) {
			// Log the error
			console.error("[TranscriptService] Error sending transcript:", error);

			// Return standardized error response
			return TranscriptResponseHandler.createErrorResponse("Failed to send transcript. Please try again later.");
		}
	}
}

//#endregion
